// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"0d9fdf75","698":"e836a47c","748":"5a284183"}[chunkId] + ".chunk.js";
};